export default __webpack_public_path__ + "static/media/PortfolioForClient.ca801ed5.png";